export default [{
    title: 'Documentos',
    icon: 'ArchiveIcon',
    children: [
        {
            title: 'Lista',
            route: 'documents-list',
            action: 'read',
		    resource: 'documents'
        },
    ]
}];